import { Provider as ReduxProvider } from 'react-redux';
import type { ReactNode } from 'react';
import { store } from '@/store';
import { Toaster } from '@/shared/ui/sonner';
import { QueryProvider } from './QueryProvider';
import { ThemeProvider } from './ThemeProvider';
import { SessionRestorer } from './SessionRestorer';

/**
 * Every provider the app needs, in dependency order.
 *
 * Redux is outermost because Theme and SessionRestorer both read from it.
 */
export function Providers({ children }: { children: ReactNode }) {
  return (
    <ReduxProvider store={store}>
      <QueryProvider>
        <ThemeProvider>
          <SessionRestorer>{children}</SessionRestorer>
          <Toaster richColors closeButton />
        </ThemeProvider>
      </QueryProvider>
    </ReduxProvider>
  );
}

export { useTheme } from './ThemeProvider';
